import { isAxiosError } from 'axios'

import { extractFilename } from '../../../utils/agreement/extractFilename.ts'
import httpClient from '../../httpClient.ts'
import { FetchResponse, SubAccount } from '../dd_panel_sub_accounts/types.ts'
import { GlobalResponse, SubaccountStats } from './types.ts'

const createSubAccount = async (data: { email: string, require_certificate: boolean }) => {
  let fetchResponse = {
    data: {},
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.post(
      '/api/dd_panel_main_accounts/create_sub_account/',
      data
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.error_code
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

const getSubAccounts = async () => {
  let fetchResponse: FetchResponse = {
    data: [],
    status: 200,
    error: null
  }

  try {
    const response = await httpClient.get<SubAccount[]>(
      '/api/dd_panel_main_accounts/list_sub_accounts/'
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.error_code
      fetchResponse.status = error.response?.status as number
    }
  }

  return fetchResponse
}

const acceptAgreement = async (subAccountId: number) => {
  let fetchResponse = {
    data: {},
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.post(
      `/api/dd_panel_main_accounts/${subAccountId}/accept_agreement/`
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

const downloadAgreement = async (subAccountId: number) => {
  let fetchResponse = {
    data: undefined as Blob | undefined,
    filename: 'umowa.docx',
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.get(
      `/api/dd_panel_main_accounts/${subAccountId}/download_agreement/`,
      {
        responseType: 'blob'
      }
    )
    fetchResponse.filename = extractFilename(
      response.headers['content-disposition']
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

const getGlobalSalesStatistics = async (start_date: string, end_date: string) => {
  let fetchResponse = {
    data: {} as GlobalResponse,
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.get(
      `/api/dd_panel_main_accounts/global_sales_statistics/?start_date=${start_date}&end_date=${end_date}`,
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

const getSubaccountsSalesStatistics = async (start_date: string, end_date: string) => {
  let fetchResponse = {
    data: [] as SubaccountStats[],
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.get(
      `/api/dd_panel_main_accounts/sub_accounts_sales_statistics/?start_date=${start_date}&end_date=${end_date}`,
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

const toggleSurveys = async (subAccountId: number) => {
  let fetchResponse = {
    data: {},
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.post(
      `/api/dd_panel_main_accounts/${subAccountId}/toggle_surveys_enabled/`
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.error_code
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

const setRecommender = async (subAccountId: number, recommender: string) => {
  let fetchResponse = {
    data: {},
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.post(
      `/api/dd_panel_main_accounts/${subAccountId}/set_recommender/`, {
        recommender
      }
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.error_code
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

export const ddPanelMainAccountAPI = {
  createSubAccount,
  getSubAccounts,
  acceptAgreement,
  downloadAgreement,
  getGlobalSalesStatistics,
  getSubaccountsSalesStatistics,
  toggleSurveys,
  setRecommender
}
